var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-text"},[_c('div',{staticClass:"image-text__image"},[_c('img',{attrs:{"src":_vm.image}})]),(!!_vm.text)?_c('div',{staticClass:"image-text__text",domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }